import React from "react";
import { useAppContext } from "~hooks";
import { Helmet } from "react-helmet";

export const COLORS = {
  // Mono
  black: `#000000`,
  "black-90": `#1E1E1E`,
  "black-70": `#323232`,
  "black-60": `#4F4F4F`,
  "black-40": `#919191`,
  "black-20": `#dddee2`,
  "black-10": `#F0F0F0`,
  white: `#FFFFFF`,

  // UX
  error: `#f75757`,
  success: `#07cb9c`,

  // Client
  "classic-black": `#141414`,
  "sick-lime": `#E2FF2E`,
  "darling-mauve": `#B8B4FF`,
  "bright-pink": `#FF40B4`,
  "bright-pink-light": `#fce7f4`,
  blush: `#F58C90`,
  sunkiss: `#FFCC01`
};

const Colors = () => {
  const keysArray = Object.keys(COLORS);

  let colorsCss = `:root{`;

  keysArray.forEach((color) => {
    colorsCss += `--color-${color}: ${COLORS[color]};`;
  });

  colorsCss += `}`;

  // Primary color
  const { primaryColor } = useAppContext();
  const primaryColorCss = `:root{--primary-color: ${primaryColor}}`;

  return (
    <Helmet>
      <style>{colorsCss}</style>
      <style>{primaryColorCss}</style>
    </Helmet>
  );
};

export default Colors;
